import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button, Card, Col, Input, Row, Layout, notification, Radio } from 'antd'
import jsQR from 'jsqr'

import Navbar from '../components/Navbar'
import WebcamPanel from '../components/WebcamPanel'
import Footer from '../components/Footer'
import requests from '../services/requests'

const { Content } = Layout
const RadioGroup = Radio.Group

const INITIAL_STATE = {
  captured: false,
  loading: false,
  submitting: false,
  event: null,
  faceImage: '',
  cardImage: '',
  faces: [],
  imageData: null,
  qrcode: '',
  selectedFace: 0,
  bibId: '',
  participant: null,
}

const radioStyle = {
  display: 'block',
}

class Register extends Component {
  state = INITIAL_STATE
  componentWillMount() {
    this.setState({ event: this.props.event })
  }
  getParticipant = async (bibId) => {
    if (bibId && bibId !== '') {
      try {
        const participant = await requests.get(`/participant/${this.props.event.id}/${bibId}`)
        this.setState({ participant })
      } catch (err) {
        console.error(err)
        this.setState({ participant: null })
      }
    } else {
      this.setState({ participant: null })
    }
  }
  handleWebcam = async (image, imageData) => {
    this.setState({ faceImage: image })
    const code = jsQR(imageData.data, 640, 480)
    if (code && code.chunks[0] && code.chunks[0].type === 'byte') {
      const arr = code.data.split('/')
      const bibId = arr[arr.length - 1]
      this.setState({ bibId })
      await this.getParticipant(bibId)
    }
  }
  handleCapture = async () => {
    this.setState({
      captured: true,
    })
    try {
      const faces = await requests.post('/detect', { image: this.state.faceImage })
      this.setState({ faces })
    } catch (err) {
      console.error(err)
    }
  }
  handleReCapture = () => {
    this.setState(state => ({ ...INITIAL_STATE, event: state.event }))
  }
  handleInputChange = async (e) => {
    const bibId = e.target.value
    this.setState({ bibId })
    await this.getParticipant(bibId)
  }
  handleRadioInputChange = (e) => {
    this.setState({ selectedFace: e.target.value })
  }
  register = async () => {
    this.setState({ submitting: true })
    const {
      faceImage,
      cardImage,
      faces,
      selectedFace,
      bibId,
    } = this.state
    const { faceRectangle } = faces[selectedFace]
    const body = {
      bibId,
      cardImage,
      faceImage,
      faceRectangle,
    }
    try {
      await requests.post(`/event/${this.props.event.id}/register`, body)
      notification.success({
        message: 'Register success',
        description: `Bib ID ${bibId}`,
      })
    } catch (err) {
      console.error(err)
      notification.error({
        message: 'Register fail',
        description: err.message,
      })
    } finally {
      this.setState({ submitting: false })
    }
  }
  render() {
    const {
      captured,
      faces,
      faceImage,
      submitting,
      selectedFace,
      bibId,
      event,
      participant,
    } = this.state
    return (
      <Layout className="layout">
        <Navbar event={event} selected="2" />
        <Content style={{ padding: '0 20px' }}>
          <div style={{ background: '#fff', padding: 24, minHeight: 'calc(100vh - 64px - 69px)' }}>
            <Row gutter={24}>
              <Col span={16} style={{ textAlign: 'center' }}>
                <WebcamPanel
                  captured={captured}
                  faces={faces}
                  previewImage={faceImage}
                  handleWebcam={(image, imageData) => this.handleWebcam(image, imageData)}
                  handleCapture={() => this.handleCapture()}
                  handleReCapture={() => this.handleReCapture()}
                />
              </Col>
              <Col span={8} style={{ overflowY: 'auto' }}>
                <Card
                  title="Register"
                  actions={[<Button type="primary" onClick={this.register} disabled={bibId === '' || submitting}>Register</Button>]}
                >
                  <h3>Bib ID: <Input type="text" name="bibId" value={bibId} onChange={this.handleInputChange} disabled={submitting} /></h3>
                  <div style={{ textAlign: 'center' }}>
                    {participant && (
                      <img src={participant.participant.profile.imageUrl} alt="face" style={{ maxWidth: '100%', maxHeight: '320px', marginBottom: '10px' }} />
                    )}
                  </div>
                  <h3>Face{faces.length > 1 ? 's' : ''}:</h3>
                  <div>
                    <RadioGroup onChange={this.handleRadioInputChange} value={selectedFace}>
                      {faces.map(({ faceId }, i) => (
                        <Radio key={faceId} style={radioStyle} value={i}>Face #{i + 1}</Radio>
                      ))}
                    </RadioGroup>
                  </div>
                </Card>
              </Col>
            </Row>
          </div>
        </Content>
        <Footer />
      </Layout>
    )
  }
}
Register.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    personGroupId: PropTypes.string,
  }),
}
Register.defaultProps = {
  event: {},
}

export default Register



// WEBPACK FOOTER //
// ./src/pages/Register.js